export const isAppUpdating = (state) => [state.appVersion.fetching, state.appVersion.installing].includes(true)
export const isFetchingAppUpdate = (state) => state.appVersion.fetching
export const isInstallAppUpdate = (state) => state.appVersion.installing
export const isAppUpdateError = (state) => !!state.appVersion.error
export const getAppUpdateErrorMsg = (state) => state.appVersion.error
